$(document).ready(function(){

	if($('#page_h1_string #search_box').length){
				var h1_searchContainer=$('#page_h1_string');

				$("#search_box .icon-search").click(function(){
					if ( !$("#search_box").hasClass("active") ) {

						h1_searchContainer.addClass('searchbox_expanded');
						$("#search_box").addClass("active");
						//$("#fs").fadeIn(300); $("#fs1").fadeIn(300);
						$("body").bind("click", check_search_focus)

						return false;

					}

				})


				$("#fs1").click(function(){
						if($("#fs").val()=="")
							return false;

				})

				var check_search_focus=function(e){
					if(!$(e.target).closest("#search_box").length){
						$("#search_box").removeClass("active");
						h1_searchContainer.removeClass('searchbox_expanded');
						//$("#fs1").hide();
						//$("#fs").fadeOut();
						$("body").unbind("click", check_search_focus)

					}
				}
	}

});
